import React from 'react'

import { Button, Modal } from '@repo/ui'

import { SupportRequestFormFields, useSupportRequestForm } from './SupportRequestForm'
import { useSupportIntake } from './SupportIntakeRoute'

/**
 * The intake modal (VRG-226 — C2). Rendered by `Layout` whenever the URL is
 * `/support/new`; see SupportIntakeRoute for why the route, not a prop, opens it.
 *
 * Deliberately reads NOTHING from the router's location hooks: it renders inside
 * `<Routes location={routesLocation}>`, so `useLocation()` here would report
 * the page BEHIND the modal. `?type=`, close and the post-submit navigation all
 * come from the intake context, which sits outside `<Routes>` and sees the real URL.
 */
export const NewSupportRequestModal = () => {
  const {
    isOpen,
    initialType,
    hasExplicitType,
    errorHandoff,
    draftKey,
    initialBody,
    contextPageUrl,
    close,
    openThread,
  } = useSupportIntake()

  const form = useSupportRequestForm({
    initialType,
    hasExplicitType,
    errorHandoff,
    draftKey,
    initialBody,
    pageUrl: contextPageUrl,
    onCreated: id => openThread(id),
  })

  return (
    <Modal
      open={isOpen}
      onClose={close}
      title="New request"
      sx={{ width: 640 }}
      actions={
        <>
          <Button variant="secondary" disableElevation onClick={close}>
            Cancel
          </Button>
          <Button
            variant="primary"
            disableElevation
            disabled={!form.canSubmit}
            onClick={form.submit}
          >
            {/* Two legs, two labels. "Submitting…" while a 9MB screenshot is
                still going up reads as a hang; naming the slow part is what
                makes on-submit upload acceptable (see the form's `submit`). */}
            {form.isUploading
              ? 'Uploading…'
              : form.isPending
                ? 'Submitting…'
                : /* Names the consequence when the user chose to add theirs to a
                     colleague's request (VRG-324). A button that still says
                     "Submit" makes it ambiguous whether the choice above it is
                     about to take effect. */
                  form.linkTo
                  ? 'Add to that request'
                  : 'Submit'}
          </Button>
        </>
      }
    >
      <SupportRequestFormFields form={form} />
    </Modal>
  )
}
